// Central SEO configuration & JSON-LD schema builders.
export const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://sdrcglobal.com").replace(/\/$/, "");

export const COMPANY = {
  name: "SDRC Global",
  legalName: "SDRC Global",
  tagline: "From Indian Farms to Global Markets",
  description:
    "SDRC Global is a premium Indian exporter of machine-clean millet, bajra (pearl millet), wheat and sesbania seed — supplying quality-assured agricultural commodities to international B2B buyers.",
  email: "sales@sdrcglobal.com",
  phone: "+91-9928845789",
  address: {
    street: "A559 Second Floor, Palam Vihar Sector 2",
    city: "Gurugram",
    region: "Haryana",
    postalCode: "122017",
    country: "IN",
  },
  areaServed: ["Middle East", "Europe", "Southeast Asia", "Africa", "North America"],
};

export const DEFAULT_OG_IMAGE =
  "https://images.unsplash.com/photo-1535379453347-1ffd615e2e08?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80";

export const absoluteUrl = (path = "/") =>
  `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;

export const absoluteImage = (src = "") => {
  if (!src) return DEFAULT_OG_IMAGE;
  if (src.startsWith("http")) return src;
  return absoluteUrl(src);
};

export const organizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${SITE_URL}/#organization`,
  name: COMPANY.name,
  legalName: COMPANY.legalName,
  url: SITE_URL,
  logo: absoluteUrl("/logo192.png"),
  description: COMPANY.description,
  email: COMPANY.email,
  telephone: COMPANY.phone,
  address: {
    "@type": "PostalAddress",
    streetAddress: COMPANY.address.street,
    addressLocality: COMPANY.address.city,
    addressRegion: COMPANY.address.region,
    postalCode: COMPANY.address.postalCode,
    addressCountry: COMPANY.address.country,
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: COMPANY.phone,
    email: COMPANY.email,
    contactType: "sales",
    areaServed: COMPANY.areaServed,
    availableLanguage: ["English"],
  },
});

export const websiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  url: SITE_URL,
  name: COMPANY.name,
  description: COMPANY.description,
  publisher: { "@id": `${SITE_URL}/#organization` },
  inLanguage: "en",
});

export const localBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${SITE_URL}/#localbusiness`,
  name: COMPANY.name,
  image: DEFAULT_OG_IMAGE,
  url: SITE_URL,
  telephone: COMPANY.phone,
  email: COMPANY.email,
  priceRange: "$$",
  address: {
    "@type": "PostalAddress",
    streetAddress: COMPANY.address.street,
    addressLocality: COMPANY.address.city,
    addressRegion: COMPANY.address.region,
    postalCode: COMPANY.address.postalCode,
    addressCountry: COMPANY.address.country,
  },
  areaServed: COMPANY.areaServed,
});

export const breadcrumbSchema = (items = []) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: absoluteUrl(it.path),
  })),
});

export const faqSchema = (faqs = []) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const productSchema = (product) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  name: product.name,
  sku: product.slug,
  image: absoluteImage(product.image),
  description: product.seoDescription || product.short,
  category: "Agricultural Commodities",
  countryOfOrigin: "IN",
  brand: { "@type": "Brand", name: COMPANY.name },
  manufacturer: { "@id": `${SITE_URL}/#organization` },
  seller: { "@id": `${SITE_URL}/#organization` },
  additionalProperty: Object.entries(product.specs || {}).map(([k, v]) => ({
    "@type": "PropertyValue",
    name: k,
    value: v,
  })),
});
